import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { CreditCardUtilities } from './credit-card';

//@Injectable({providedIn: SharedModule})
@Injectable()
export class CustomValidationService {

	public constructor() { }

	
	/**
	 * Properly escape email address
	 * @param str 
	*/
	public rfc3986EncodeURIComponent(str) {
		return encodeURIComponent(str).replace(/[']/g, '--');
	}

	
	//https://newbedev.com/angular-2-form-validations-start-date-end-date
	public dateLessThan(dateField1: string, dateField2: string, validatorField: { [key: string]: boolean }): ValidatorFn {
		return (c: AbstractControl): { [key: string]: boolean } | null => {
			const date1 = c.get(dateField1).value;
			const date2 = c.get(dateField2).value;
			if ((date1 !== null && date2 !== null) && date1 > date2) {
				return validatorField;
			}
			return null;
		};
	}


	// /**
	//  * Check if matches user/pass regex
	//  * may contain the following symbols: _.-!@#
	//  * @param control 
	//  */
	// public userPassRegex(control: FormControl): { [s: string]: boolean } {
	// 	let pattern = /^[a-zA-Z0-9_.\-!@#]*$/;

	// 	if (!pattern.test(control.value)) {
	// 		return { input: true };
	// 	}
	// 	return null;
	// }



	/**
	 * Check if Valid expiration date for pattern MM/YY
	 * @param control 
	*/
	public expirationDateMMYY(control: FormControl): { [s: string]: boolean } {
		let pattern = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/,
			val = control.value;
		//console.log('zipCodeValidation:', val);
		if(!val) return null;

		if (!pattern.test(control.value)) {
			return { pattern: true };
		}
		return null;
	}



	/**
	 * Check if Valid Zipcode is entered into input
	 * @param control 
	*/
	public zipCodeValidation(control: FormControl): { [s: string]: boolean } {
		let pattern = /^[0-9]{5}(?:-[0-9]{4})?$/,
			val = control.value;
		//console.log('zipCodeValidation:', val);
		if(!val) return null;

		if (!pattern.test(control.value)) {
			return { pattern: true };
		}
		return null;
	}


	/**
	 * Check if Valid INTERNATIONAL Zipcode is entered into input
	 * @param control 
	*/
	public zipCodeInternationalValidation(control: FormControl): { [s: string]: boolean } {
		let val = control.value;
		//console.log('zipCodeInternationalValidation:', val);
		if(!val) return null;

		if (val.match(/^[0-9A-Za-z- ]+$/) === null || val.length < 4 || val.length > 10) { 
			return { pattern: true };
		}
		return null;
	}



	// /**
	//  * Check if Valid INTERNATIONAL Zipcode is entered into input
	//  * https://stackoverflow.com/questions/578406/what-is-the-ultimate-postal-code-and-zip-regex/19844362#19844362
	//  * @param control 
	// */
	// public zipCodeInternationalValidation2(control: FormControl): { [s: string]: boolean } {
	// 	let pattern = /^[0-9a-zA-Z]{5}(?:-[0-9a-zA-Z]{4})?$/,
	// 		val = control.value;
	// 	console.log('zipCodeInternationalValidation:', val);
	// 	if(!val) return null;

	// 	if (!pattern.test(control.value)) {
	// 		return { pattern: true };
	// 	}
	// 	return null;
	// }


	/**
	 * Check if Valid Email is entered into input
	 * @param control 
	*/
	public authEmailValidation(control: FormControl): { [s: string]: boolean } {
		let pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (!pattern.test(control.value)) {
			return { email: true };
		}
		return null;
	}
	
	/**
	 * Same as above but, for just strings instead of formControllers
	 * @param inputString 
	 * @returns 
	 */
	public emailStringValidation(inputString: string){
		let pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (!pattern.test(inputString)) {
			return { email: true };
		}
		return null;
	}



	/**
	 * Check if Valid string is entered into input
	 * @param control 
	*/
	public integersOnlyValidation(control: FormControl): { [key: string]: any } {

		//console.log('integersOnlyValidation');
		let pattern_regex = /^[0-9]+$/;

		//console.log('pattern_regex.test: ' + pattern_regex.test(control.value));
		if (!pattern_regex.test(control.value)) {
			return { pattern: true };
		}
		return null;
	}



	/**
	 * Minimum Value Validator
	 * http://stackoverflow.com/questions/36756159/angular-2-custom-validator-with-parameters
	*/
	public minValueValidator = (min: number) => {
		return (control: FormControl) => {
			var num = +control.value;
			//console.log('minValueValidator: ' + min + ' vs ' + num);
			if (isNaN(num) || num < min) {
				return {
					minValue: { valid: false }
				};
			}
			return null;
		};
	};

	/**
	 * Maximum Value Validator
	*/
	public maxValueValidator = (max: number) => {
		return (control: FormControl) => {
			var num = +control.value;
			//console.log('maxValueValidator: ' + max + ' vs ' + num);
			if (isNaN(num) || num > max) {
				return {
					maxValue: { valid: false }
				};
			}
			return null;
		};
	};


	/**
     * Credit card validation
     * @param control
     * @return {any}
    */
	public ccValidation(control: FormControl): { [key: string]: any } {
		//console.log('ccValidation.control', control);
		
		if (control == null) return null;
		let cc = control.value;
		//console.log('ccValidation.cc', cc);
		if (cc == null) return null;//{ cc: false };
		// if (cc.length < 7) return { cc: false };
		// if (cc.length > 19) return { cc: false };

		if (CreditCardUtilities.luhn(cc)) {
			return null;// { cc: false }
		}

		return { cc: true };
	}


}